import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  MaterialReactTable,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFiltersButton,
  MRT_FullScreenToggleButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table';
import {
  Avatar,
  AvatarGroup,
  Checkbox,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip
} from '@mui/material';
import {
  Box,
  Button,
  IconButton,
  Grid,
  TextField,
  Autocomplete,
  Paper
} from '@mui/material';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import CloseIcon from '@mui/icons-material/Close';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import { ToastContainer } from 'react-toastify';
import './CreateUser.css';
import {
  GetUsers,
  AgencyAdminGetProfile,
  GetUserRoles,
  CreateAgencyUser,
  GetAgencyLocations,
  ResendPassword,
  UploadUserProfileImage
} from '../../apis/Agency';
import { successToast, ErrorToast } from '../../components/Toasts';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import UploadIcon from '@mui/icons-material/Upload';
import { MetaTags } from 'react-meta-tags';
import { base_logo_url, base_url } from '../../apis/constants';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import AddLocations from '../Locations/AddLocations';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

function UserManagement(props) {
  const actionFrom = props.location?.state?.from || '';
  const selecedUserForRole = props.location?.state?.selectedUser || null;
  const selecedUserLocations = props.location?.state?.agencyLocations || null;
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const [createLocPermission, setCreateLocPermission] = useState(null);
  const [createLocDialog, setCreateLocDialog] = useState(false);
  const loggedInEmail = useSelector(state => state.userDetails.email);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );

  const [currentView, setCurrentView] = useState('list');
  const [phoneNumberValidError, setPhoneNumberValidError] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [createAgencyLoader, setCreateAgencyLoader] = useState(false);
  const options = ['Active', 'In-Active'];
  const [adminRoles, setAdminRoles] = useState(null);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userProfileImg, setUserProfileImg] = useState('');
  const [adminActiveValue, setAdminActiveValue] = useState(options[0]);
  const [adminStatus, setAdminStatus] = useState(true);
  const [adminBase64Image, setAdminBase64Image] = useState(null);
  const [adminSimpleImage, setAdminSimpleImage] = useState(null);
  const [agencyLocations, setAgencyLocations] = useState(null);
  const [userLocations, setUserLocations] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [shipmentsLoader, setShipmentsLoader] = useState(true);
  const [userPermissionsArr, setUserPermissionsArr] = useState(null);
  const [disableCreateUserBtn, setDisableCreateUserBtn] = useState(false);
  const [editedData, setEditedData] = useState(null);
  const [adminRoleValue, setAdminRoleValue] = useState({
    id: '',
    roleName: ''
  });

  const history = useHistory();
  useEffect(() => {
    const filteredCarrierPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Users'
    );
    const LocationsPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Locations'
    );
    setUserPermissionsArr(filteredCarrierPermissions);
    setCreateLocPermission(LocationsPermissions);
  }, [userRolePermissions]);

  const fetchUsers = () => {
    GetUsers(AgencyID)
      .then(response => {
        if (response.status === 200) {
          setShipmentsLoader(false);
          const filteredUsers = response?.data?.data?.filter(
            users => !users.isAdmin
          );
          setAllUsers(filteredUsers);
        }
      })
      .catch(err => {
        setShipmentsLoader(false);
        setAllUsers([]);
        console.log('eeeeeeeee', err.message);
      });
  };

  const fetchAgencyLocations = () => {
    GetAgencyLocations(AgencyID, 0)
      .then(response => {
        if (response.status === 200) {
          const filteredData = response?.data?.data.map(
            ({ locationCarriers, ...rest }) => rest
          );
          setAgencyLocations(filteredData);
        }
      })
      .catch(err => console.log('eeeeeeeee', err.message));
  };

  const fetchUserRoles = () => {
    GetUserRoles(AgencyID)
      .then(response => {
        if (response.status === 200) {
          let rolesData = response?.data?.data
            .filter(item => item.roleName !== 'Default')
            .reverse();
          console.log(rolesData, 'rolesData');
          setAdminRoles(rolesData);
          if (actionFrom === 'role-management' && selecedUserForRole) {
            // setTimeout(() => {
            // fetchAgencyLocations();
            handleEditUser(
              null,
              selecedUserForRole,
              rolesData,
              selecedUserLocations
            );
            setAdminRoleValue(rolesData[0]);
            // }, 10);
          }
        }
      })
      .catch(err => console.log('eeeeeeeee', err.message));
  };

  useEffect(() => {
    fetchUsers();
    fetchUserRoles();
    fetchAgencyLocations();
  }, []);

  const handdleExistedUserValidation = () => {
    const errors = {};
    errors['emailError'] = 'User exist with this email try another one';
    setValidationErrors(errors);
    setDisableCreateUserBtn(false);
  };

  const handleSuccessCreateAgency = (ApiRes, id) => {
    setCreateAgencyLoader(false);
    successToast(
      id ? 'User updated successfully!' : 'User created successfully!'
    );
    setCurrentView('list');
    fetchUsers();
    setAdminSimpleImage('');
    setAdminBase64Image('');
    setAdminStatus('');
    setDisableCreateUserBtn(false);
    setSelectedUser('');
    setUserProfileImg('');
  };

  const handleCreateUserReq = () => {
    setCreateAgencyLoader(true);

    let createObj = {
      id: currentView === 'edit' ? selectedUser.id : 0,
      role: adminRoleValue.id,
      firstName: firstName,
      lastName: lastName,
      loginId: email,
      password: '',
      email: email,
      notes: '',
      agencyId: AgencyID,
      phoneNumber: phoneNumber,
      status: adminStatus,
      assignedLocations: userLocations.map(obj => obj?.id),
      avatar: userProfileImg ? userProfileImg : selectedUser.avatar
    };
    CreateAgencyUser(createObj)
      .then(
        res =>
          res.status === 200 && handleSuccessCreateAgency(res, selectedUser.id)
      )
      .catch(err => {
        ErrorToast(err?.message);
        console.log('eeeeeeeeeeeee', err);
        setCreateAgencyLoader(false);
        setDisableCreateUserBtn(false);
        setSelectedUser('');
        setUserProfileImg('');
      });
  };

  const ValidatUserEmail = () => {
    setDisableCreateUserBtn(true);
    AgencyAdminGetProfile(email)
      .then(res => res.status === 200 && handdleExistedUserValidation())
      .catch(err => handleCreateUserReq());
  };

  const handlePhoneNumberPaste = event => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text/plain');
    const cleanedText = pastedText.replace(/\D/g, '');
    const formattedValue = cleanedText.replace(
      /^(\d{3})(\d{3})(\d{4})$/,
      '($1) $2-$3'
    );
    setPhoneNumber(formattedValue);

    const errors = {};
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const isValidPhoneNumber = phoneRegex.test(formattedValue);

    if (isValidPhoneNumber) {
      setPhoneNumberValidError(false);
      setValidationErrors({ ...validationErrors, phoneNumberError: null });
    } else {
      setPhoneNumberValidError(true);
      errors['phoneNumberError'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    }
  };

  const handleSignUp = () => {
    let errors = {};
    if (!firstName) {
      errors['firstNameError'] = 'Enter First Name';
    } else if (!lastName) {
      errors['lastNameError'] = 'Enter Last Name';
    } else if (!email) {
      errors['emailError'] = 'Enter Email';
    } else if (!phoneNumber) {
      errors['phoneNumberError'] = 'Enter Phone Number';
    } else if (phoneNumberValidError) {
      errors['phoneNumberError'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
    } else if (!isValidEmail) {
      errors['emailError'] = 'Enter Valid Email';
    } else if (adminRoleValue.roleName === '') {
      errors['roleName'] = 'Select user role';
    } else if (userLocations.length === 0) {
      errors['locationsError'] = 'Select Atleast One Location';
    } else {
      currentView === 'edit' ? handleCreateUserReq() : ValidatUserEmail();
    }

    setValidationErrors(errors);
  };

  const handleResendEmailRequest = (event, rowData) => {
    event.stopPropagation();
    ResendPassword(rowData.loginId)
      .then(
        res => res.status === 200 && successToast('Email sent successfully!')
      )
      .catch(err => ErrorToast('Network Error'));
  };

  const userColumns = [
    {
      accessorFn: row => `${row.firstName} ${row.lastName}`,
      id: 'name',
      header: 'User Name',
      size: 10,
      Cell: ({ cell, row }) => (
        <>
          <Box
            sx={
              isMobile
                ? { display: 'flex', alignItems: 'center' }
                : { display: 'flex', alignItems: 'center', marginLeft: 3 }
            }
          >
            <AvatarGroup spacing='small'>
              <Avatar
                sx={{
                  bgcolor: 'ButtonFace',
                  objectFit: 'contain',
                  height: 40
                }}
                imgProps={{
                  style: {
                    height: 40
                  }
                }}
                src={base_logo_url + row.original.avatar}
              />
            </AvatarGroup>
            <span class='mx-0'>{cell.getValue()}</span>
          </Box>
          {!isMobile && (
            <div
              className={'table-row-buttons-users py-0'}
              style={{ marginLeft: '-4.5vw' }}
            >
              {((userPermissionsArr &&
                userPermissionsArr.filter(permissions => permissions.level4)
                  .length) ||
                UserIsAdmin) && (
                <button
                  onClick={event =>
                    handleResendEmailRequest(event, row.original)
                  }
                  class=' bg-white border-0 p-2 fw-bold'
                >
                  <Tooltip title='Resend Password'>
                    <svg
                      fill='rgb(51, 97, 255)'
                      width='24px'
                      height='16px'
                      viewBox='0 0 64.00 64.00'
                      data-name='Layer 1'
                      id='Layer_1'
                      xmlns='http://www.w3.org/2000/svg'
                      stroke='rgb(51, 97, 255)'
                      stroke-width='2.944'
                    >
                      <g id='SVGRepo_bgCarrier' stroke-width='0' />
                      <g
                        id='SVGRepo_tracerCarrier'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                        stroke='#CCCCCC'
                        stroke-width='0.256'
                      />
                      <g id='SVGRepo_iconCarrier'>
                        <title />
                        <path d='M55.43,55.68H8.57a5.51,5.51,0,0,1-5.5-5.5V13.82a5.51,5.51,0,0,1,5.5-5.5H55.43a5.51,5.51,0,0,1,5.5,5.5V50.18A5.51,5.51,0,0,1,55.43,55.68ZM8.57,11.32a2.5,2.5,0,0,0-2.5,2.5V50.18a2.5,2.5,0,0,0,2.5,2.5H55.43a2.5,2.5,0,0,0,2.5-2.5V13.82a2.5,2.5,0,0,0-2.5-2.5Z' />
                        <path d='M32,27.21a2,2,0,0,1-.42-.05l-17.25-5a1.5,1.5,0,0,1,.84-2.89L32,24.15l16.83-4.88a1.5,1.5,0,0,1,.84,2.89l-17.25,5A2,2,0,0,1,32,27.21Z' />
                        <path d='M39.14,49a1.49,1.49,0,0,1-1.06-.44L34.9,45.34A1.51,1.51,0,0,1,36,42.77H51.82a1.5,1.5,0,0,1,0,3H39.59l.61.62a1.51,1.51,0,0,1,0,2.12A1.53,1.53,0,0,1,39.14,49Z' />
                        <path d='M36,45.77a1.5,1.5,0,0,1-1.06-2.56L38.08,40a1.5,1.5,0,1,1,2.12,2.12L37,45.34A1.48,1.48,0,0,1,36,45.77Z' />
                      </g>
                    </svg>
                  </Tooltip>
                </button>
              )}
              {((userPermissionsArr &&
                userPermissionsArr.filter(permissions => permissions.level4)
                  .length) ||
                userPermissionsArr.filter(permissions => permissions.level2)
                  .length ||
                UserIsAdmin) && (
                <button
                  onClick={event => handleEditUser(event, row.original)}
                  class='mx-2 bg-white border-0 p-2 fw-bold'
                  style={{ color: '#3361FF', borderRadius: '4px' }}
                >
                  <Tooltip title='View / Update'>
                    <svg
                      className='MX-1'
                      width='17'
                      height='17'
                      viewBox='0 0 13 13'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.33333 11.1693H2.26667L8.01667 5.41927L7.08333 4.48594L1.33333 10.2359V11.1693ZM10.8667 4.4526L8.03333 1.6526L8.96667 0.719271C9.22222 0.463715 9.53611 0.335938 9.90833 0.335938C10.2806 0.335938 10.5944 0.463715 10.85 0.719271L11.7833 1.6526C12.0389 1.90816 12.1722 2.21649 12.1833 2.5776C12.1944 2.93872 12.0722 3.24705 11.8167 3.5026L10.8667 4.4526ZM9.9 5.43594L2.83333 12.5026H0V9.66927L7.06667 2.6026L9.9 5.43594Z'
                        fill='#3361FF'
                      />
                    </svg>
                  </Tooltip>
                </button>
              )}
            </div>
          )}
        </>
      )
    },
    {
      accessorKey: 'phone',
      id: 'phone',
      header: 'Phone Number',
      size: 70,
      Cell: ({ cell }) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span class='mx-1'>{cell.getValue()}</span>
        </Box>
      )
    },
    {
      accessorKey: 'loginId',
      id: 'email',
      header: 'Email',
      size: 70,
      Cell: ({ cell }) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span class='mx-1'>{cell.getValue()}</span>
        </Box>
      )
    },
    {
      accessorKey: 'roleName',
      id: 'role',
      header: 'Role',
      size: 70,
      Cell: ({ cell }) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span class='mx-1'>{cell.getValue()}</span>
        </Box>
      )
    },
    {
      accessorKey: 'active',
      id: 'status',
      header: 'Status',
      size: 70,
      Cell: ({ cell }) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {cell.getValue() ? (
            <span class='mx-1 text-success'>
              ACTIVE{' '}
              <svg
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M8.99719 4.3725L11.3747 6.75L12.4322 5.6925L8.99719 2.25L5.55469 5.6925L6.61969 6.75L8.99719 4.3725ZM8.99719 13.6275L6.61969 11.25L5.56219 12.3075L8.99719 15.75L12.4397 12.3075L11.3747 11.25L8.99719 13.6275Z'
                  fill='#2E7D32'
                />
              </svg>
            </span>
          ) : (
            <span class='mx-1 text-muted'>
              INACTIVE{' '}
              <svg
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M8.99719 4.3725L11.3747 6.75L12.4322 5.6925L8.99719 2.25L5.55469 5.6925L6.61969 6.75L8.99719 4.3725ZM8.99719 13.6275L6.61969 11.25L5.56219 12.3075L8.99719 15.75L12.4397 12.3075L11.3747 11.25L8.99719 13.6275Z'
                  fill='black'
                  fill-opacity='0.6'
                />
              </svg>
            </span>
          )}
        </Box>
      )
    }
  ];

  const handlePrint = () => {};

  const handleAdminImageUpload = event => {
    const file = event.target.files[0];
    const reader = new FileReader();

    const imageType = /image.*/;
    if (!file?.type?.match(imageType)) {
      ErrorToast('Only image files are allowed');
    }
    if (file?.type?.match(imageType)) {
      reader.onloadend = () => {
        setAdminSimpleImage(reader.result);
      };

      reader.readAsDataURL(file);
      let formData = new FormData();
      formData.append('file', file);
      var formdata = new FormData();
      formdata.append('file', file);
      setDisableCreateUserBtn(true);
      UploadUserProfileImage(email ? email : loggedInEmail, formdata)
        .then(res => {
          res.status === 200 && setUserProfileImg(res.data.data);
          setDisableCreateUserBtn(false);
        })
        .catch(err => {
          setDisableCreateUserBtn(false);
          ErrorToast(err.message);
        });
    }
  };

  const handleAdminStatusChange = (event, newValue) => {
    setAdminActiveValue(newValue);
    if (newValue === 'Active') {
      setAdminStatus(true);
    } else {
      setAdminStatus(false);
    }
  };

  const handleAdminRoleChange = (event, newValue) => {
    setAdminRoleValue(newValue);
    setValidationErrors({
      ...validationErrors,
      roleName: null
    });
  };

  const handleAdminLocationChange = (event, newValue) => {
    setUserLocations(newValue);
    setValidationErrors({
      ...validationErrors,
      locationsError: null
    });
  };

  const handlePhoneNumberChange = event => {
    const inputValue = event.target.value;
    const formattedValue = inputValue
      .replace(/\D/g, '')
      .replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
    setPhoneNumber(formattedValue);

    const errors = {};
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const isValidPhoneNumber = phoneRegex.test(formattedValue);

    if (isValidPhoneNumber) {
      setPhoneNumberValidError(false);
      setValidationErrors({ ...validationErrors, phoneNumberError: null });
    } else {
      setPhoneNumberValidError(true);
      errors['phoneNumberError'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    }
  };

  const handleEmailValidation = email => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const errors = {};
    setEmail(email);

    if (emailRegex.test(email)) {
      setIsValidEmail(true);
      setValidationErrors({
        ...validationErrors,
        emailError: null
      });
    } else {
      setIsValidEmail(false);
      errors['emailError'] = 'Enter Valid Email';
    }
    setValidationErrors(errors);
  };

  const handleAddUser = () => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setPhoneNumber('');
    setAdminActiveValue(options[0]);
    setAdminStatus(true);
    setUserLocations([]);
    setAdminRoleValue({ id: '', roleName: '' });
    setCurrentView('create');
  };

  const handleUserLocations = (userLocations, selecedUserLocations) => {
    console.log(userLocations, agencyLocations, 'userLocations');
    let tempArr = [];
    for (let i = 0; i < userLocations.length; i++) {
      const locationId = userLocations[i].id;
      const filterdAssignedLocation = (
        agencyLocations ? agencyLocations : selecedUserLocations
      ).find(locations => locationId === locations.id);
      tempArr.push(filterdAssignedLocation);
    }
    setUserLocations(tempArr);
  };

  const handleEditUser = (event, rowData, rolesData) => {
    console.log(rowData, event, 'rowData');
    setEditedData(rowData);
    setSelectedUser(rowData);
    setFirstName(rowData.firstName);
    setLastName(rowData.lastName);
    setEmail(rowData.loginId);
    rowData.avatar && setAdminBase64Image(rowData.avatar);
    setPhoneNumber(rowData.phone);
    setAdminActiveValue(rowData.active ? options[0] : options[1]);
    setAdminStatus(rowData.active ? true : false);
    setAdminRoleValue('');
    setUserLocations([]);
    const selectedRoles = adminRoles ? adminRoles : rolesData;
    AgencyAdminGetProfile(rowData.loginId)
      .then(res => {
        if (res.status === 200) {
          setAdminRoleValue(
            selectedRoles.filter(
              role => role.id === res.data.data.userInfo.roleId
            )[0]
          );
          handleUserLocations(
            res.data.data.assignedLocations,
            selecedUserLocations
          );
        }
      })
      .catch(err => console.log('eeerrrooorrr', err.message));

    setCurrentView('edit');
    if (event?.stopPropagation) {
      event.stopPropagation();
    }
  };

  const isMobile = useIsMobile();
  const handleClickOpen = () => {
    setCreateLocDialog(true);
  };

  const handleClose = button => {
    setCreateLocDialog(false);
    button === 'save' && fetchAgencyLocations();
  };
  const renderUserForm = () => (
    <Paper
      sx={
        isMobile
          ? {
              display: 'flex',
              width: '90vw',
              height: '90vh',
              justifyContent: 'center'
            }
          : { justifyContent: 'center', height: '83vh' }
      }
      className={isMobile ? 'Grid_Item_User_mobile' : 'Grid_Item_User'}
    >
      <Box sx={isMobile ? { width: '85vw' } : {}}>
        <Grid
          className=''
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse',
            position: 'relative'
          }}
        >
          <IconButton
            aria-label='delete'
            style={{ position: 'absolute', top: 10 }}
            onClick={() => {
              setCurrentView('list');
              setAdminSimpleImage('');
              setAdminBase64Image('');
              setEditedData(null);
              setValidationErrors({});
            }}
          >
            <CloseIcon color='error' />
          </IconButton>
        </Grid>

        <Grid sx={{ height: '70vh' }}>
          <Grid sx={{ backgroundColor: '#e6d4c2', borderRadius: 2, mt: 1 }}>
            <Grid sx={{ height: 120 }}>
              <div>
                <input
                  disabled={
                    (userPermissionsArr &&
                      (userPermissionsArr.filter(
                        permissions => permissions.level4
                      ).length ||
                        userPermissionsArr.filter(
                          permissions => permissions.level2
                        ).length)) ||
                    UserIsAdmin
                      ? false
                      : true
                  }
                  type='file'
                  accept='image/*'
                  onChange={handleAdminImageUpload}
                  style={{ display: 'none' }}
                  id='image-upload'
                />
                <label htmlFor='image-upload'>
                  {adminBase64Image || adminSimpleImage ? (
                    <img
                      className='Admin_Img'
                      src={
                        adminSimpleImage
                          ? adminSimpleImage
                          : base_logo_url + adminBase64Image
                      }
                      alt='adminBase64Image'
                      width='200'
                      style={{
                        borderRadius: '50%',
                        objectFit: 'cover',
                        cursor: 'pointer'
                      }}
                    />
                  ) : (
                    <span
                      role='img'
                      aria-label='upload icon'
                      className='Admin_Img'
                      style={{
                        display: 'inline-block',
                        borderRadius: '50%',
                        backgroundColor: '#e5e5e5',
                        textAlign: 'center',
                        lineHeight: '120px',
                        cursor: 'pointer'
                      }}
                    >
                      <UploadIcon />
                      Upload
                    </span>
                  )}
                </label>
              </div>
            </Grid>
          </Grid>

          <Grid sx={{ mt: 7 }}>
            <Grid container>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextField
                  fullWidth
                  disabled={
                    (userPermissionsArr &&
                      ((userPermissionsArr.filter(
                        permissions => permissions.level3
                      ).length &&
                        !editedData) ||
                        (userPermissionsArr.filter(
                          permissions => permissions.level4
                        ).length &&
                          editedData))) ||
                    UserIsAdmin
                      ? false
                      : true
                  }
                  variant='standard'
                  FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                  error={Boolean(validationErrors['firstNameError'])}
                  helperText={validationErrors['firstNameError']}
                  onChange={e => {
                    const isValid = /^[A-Za-z\s\-]+$/.test(e.target.value);
                    (isValid || e.target.value === '') &&
                      setFirstName(e.target.value);
                    setValidationErrors({
                      ...validationErrors,
                      firstNameError: null
                    });
                  }}
                  value={firstName}
                  required
                  inputProps={{ style: { fontSize: 13 } }}
                  size='small'
                  label='First Name'
                  type='text'
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextField
                  fullWidth
                  disabled={
                    (userPermissionsArr &&
                      ((userPermissionsArr.filter(
                        permissions => permissions.level3
                      ).length &&
                        !editedData) ||
                        (userPermissionsArr.filter(
                          permissions => permissions.level4
                        ).length &&
                          editedData))) ||
                    UserIsAdmin
                      ? false
                      : true
                  }
                  variant='standard'
                  FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                  error={Boolean(validationErrors['lastNameError'])}
                  helperText={validationErrors['lastNameError']}
                  onChange={e => {
                    const isValid = /^[A-Za-z\s\-]+$/.test(e.target.value);
                    (isValid || e.target.value === '') &&
                      setLastName(e.target.value);
                    setValidationErrors({
                      ...validationErrors,
                      lastNameError: null
                    });
                  }}
                  value={lastName}
                  required
                  inputProps={{ style: { fontSize: 13 } }}
                  sx={isMobile ? { mt: 1 } : { ml: 1 }}
                  size='small'
                  label='Last Name'
                  type='text'
                />
              </Grid>
            </Grid>

            <Grid container sx={isMobile ? { mt: 1 } : { mt: 3 }}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextField
                  fullWidth
                  variant='standard'
                  FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                  error={Boolean(validationErrors['emailError'])}
                  helperText={validationErrors['emailError']}
                  onChange={e => handleEmailValidation(e.target.value)}
                  value={email}
                  disabled={currentView === 'edit'}
                  required
                  inputProps={{ style: { fontSize: 13 } }}
                  size='small'
                  label='Email Address'
                  type='email'
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <TextField
                  fullWidth
                  disabled={
                    (userPermissionsArr &&
                      ((userPermissionsArr.filter(
                        permissions => permissions.level3
                      ).length &&
                        !editedData) ||
                        (userPermissionsArr.filter(
                          permissions => permissions.level4
                        ).length &&
                          editedData))) ||
                    UserIsAdmin
                      ? false
                      : true
                  }
                  variant='standard'
                  FormHelperTextProps={{ style: { margin: ' 5 30 0 0' } }}
                  error={Boolean(validationErrors['phoneNumberError'])}
                  helperText={validationErrors['phoneNumberError']}
                  onChange={handlePhoneNumberChange}
                  onPaste={handlePhoneNumberPaste}
                  value={phoneNumber}
                  required
                  sx={isMobile ? { mt: 1 } : { ml: 1 }}
                  size='small'
                  label='Phone Number'
                  type='text'
                  inputProps={{
                    maxLength: 10,
                    style: { fontSize: 13 }
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              sx={
                isMobile
                  ? { mt: 1 }
                  : { mt: 3, display: 'flex', justifyContent: 'space-between' }
              }
            >
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Autocomplete
                  disabled={
                    (userPermissionsArr &&
                      ((userPermissionsArr.filter(
                        permissions => permissions.level3
                      ).length &&
                        !editedData) ||
                        (userPermissionsArr.filter(
                          permissions => permissions.level4
                        ).length &&
                          editedData))) ||
                    UserIsAdmin
                      ? false
                      : true
                  }
                  fullWidth
                  size='small'
                  disableClearable
                  value={adminRoleValue}
                  onChange={(event, newValue) => {
                    if (newValue?.isButton) {
                      setCreateLocDialog(true);
                    } else {
                      handleAdminRoleChange(event, newValue);
                    }
                  }}
                  renderOption={(props, option) => {
                    if (option.isButton) {
                      return (
                        <li
                          {...props}
                          key='create-role-button'
                          style={{ fontSize: 13 }}
                        >
                          <Button
                            fullWidth
                            sx={{
                              justifyContent: 'flex-start',
                              fontSize: '13px',
                              textTransform: 'none' // removes uppercase transformation
                            }}
                            variant='text'
                            size='small'
                            onClick={e => {
                              e.stopPropagation();
                              history.push({
                                pathname: '/roles',
                                state: {
                                  from: 'user-management',
                                  selectedUser: editedData,
                                  agencyLocations: agencyLocations
                                }
                              });
                            }}
                          >
                            + Create Role
                          </Button>
                        </li>
                      );
                    }
                    return (
                      <Box
                        component='li'
                        {...props}
                        key={option.id || option.roleName}
                        sx={{ fontSize: 13 }}
                      >
                        {option.roleName}
                      </Box>
                    );
                  }}
                  getOptionLabel={option => {
                    if (option.isButton) return '';
                    return option.roleName || '';
                  }}
                  options={[
                    {
                      isButton: true,
                      roleName: '+ Create Role',
                      id: 'create-role'
                    },
                    ...adminRoles
                  ]}
                  renderInput={params => (
                    <TextField
                      FormHelperTextProps={{
                        style: { margin: '5 30 0 0' }
                      }}
                      error={Boolean(validationErrors['roleName'])}
                      helperText={validationErrors['roleName']}
                      label='Role'
                      variant='standard'
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        style: { fontSize: 13 }
                      }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) => {
                    if (option.isButton || value?.isButton) return false;
                    return option.id === value?.id;
                  }}
                  ListboxProps={{
                    sx: {
                      '& li': {
                        fontSize: 13 // Ensures all list items have font size 13
                      }
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Autocomplete
                  fullWidth
                  disabled={
                    (userPermissionsArr &&
                      ((userPermissionsArr.filter(
                        permissions => permissions.level3
                      ).length &&
                        !editedData) ||
                        (userPermissionsArr.filter(
                          permissions => permissions.level4
                        ).length &&
                          editedData))) ||
                    UserIsAdmin
                      ? false
                      : true
                  }
                  sx={isMobile ? { mt: 1 } : { ml: 1 }}
                  size='small'
                  disableClearable
                  value={adminActiveValue}
                  onChange={(event, newValue) =>
                    handleAdminStatusChange(event, newValue)
                  }
                  renderOption={(PreviousProps, option) => (
                    <Box style={{ fontSize: 13 }} {...PreviousProps}>
                      {option}
                    </Box>
                  )}
                  options={options}
                  renderInput={params => (
                    <TextField
                      label='Status'
                      variant='standard'
                      {...params}
                      inputProps={{
                        ...params.inputProps,
                        style: { fontSize: 13 }
                      }}
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid
              sx={{
                mt: 3,
                display: 'flex',
                justifyContent: 'space-between'
              }}
            >
              <Autocomplete
                disabled={
                  (userPermissionsArr &&
                    ((userPermissionsArr.filter(
                      permissions => permissions.level3
                    ).length &&
                      !editedData) ||
                      (userPermissionsArr.filter(
                        permissions => permissions.level4
                      ).length &&
                        editedData))) ||
                  UserIsAdmin
                    ? false
                    : true
                }
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                multiple
                // sx={{ mt: 2 }}
                className='w-100'
                size='small'
                disableClearable
                value={userLocations}
                onChange={(event, newValue) => {
                  const sall = newValue.filter(loc => loc.selectAll === true);
                  if (sall.length > 0) {
                    if (userLocations.length === agencyLocations.length) {
                      handleAdminLocationChange(event, []);
                    } else {
                      handleAdminLocationChange(event, agencyLocations);
                    }
                  } else {
                    handleAdminLocationChange(
                      event,
                      newValue.filter(loc => !loc.selectAll && !loc.isButton)
                    );
                  }
                }}
                renderOption={(props, option, { selected }) => {
                  const formatLocation = option => {
                    if (!option) return '';
                    if (option.selectAll) return 'Select All';
                    if (option.isButton) return '';

                    const rest = [
                      option.city,
                      option.state || option.stateOrProvinceCode,
                      option.postalCode,
                      option.countryCode
                    ]
                      .filter(Boolean)
                      .join(' ');

                    return option.name ? `${option.name}: ${rest}` : rest;
                  };
                  if (option.isButton) {
                    if (
                      createLocPermission.filter(
                        permissions => permissions.level3
                      ).length ||
                      UserIsAdmin
                    ) {
                      return (
                        <li {...props} style={{ justifyContent: 'left' }}>
                          <Button
                            sx={{ ml: 2 }}
                            variant='text'
                            size='small'
                            onClick={e => {
                              e.stopPropagation();
                              setCreateLocDialog(true);
                            }}
                          >
                            + Create Location
                          </Button>
                        </li>
                      );
                    } else return null;
                  }

                  return (
                    <li {...props}>
                      <Checkbox
                        icon={<CheckBoxOutlineBlankIcon fontSize='small' />}
                        checkedIcon={<CheckBoxIcon fontSize='small' />}
                        style={{ marginRight: 8 }}
                        checked={
                          option.selectAll
                            ? userLocations.length === agencyLocations.length
                            : selected
                        }
                        onChange={e => {
                          if (option.selectAll) {
                            e.stopPropagation();
                          }
                        }}
                      />
                      {formatLocation(option)}
                    </li>
                  );
                }}
                getOptionLabel={option => {
                  const formatLocation = option => {
                    if (!option) return '';
                    if (option.selectAll) return 'Select All';
                    if (option.isButton) return '';

                    const rest = [
                      option.city,
                      option.state || option.stateOrProvinceCode,
                      option.postalCode,
                      option.countryCode
                    ]
                      .filter(Boolean)
                      .join(' ');

                    return option.name ? `${option.name}: ${rest}` : rest;
                  };
                  return formatLocation(option);
                }}
                options={
                  agencyLocations?.length === 0 || agencyLocations?.length === 1
                    ? [
                        { name: 'Create Location', isButton: true },
                        ...agencyLocations
                      ]
                    : agencyLocations?.length > 1
                    ? [
                        { name: 'Create Location', isButton: true },
                        { name: 'Select All', selectAll: true },
                        ...agencyLocations
                      ]
                    : []
                }
                renderInput={params => (
                  <TextField
                    sx={
                      userLocations.length > 2
                        ? {
                            height: 60,
                            padding: 1,
                            overflowY: 'scroll',
                            overflowX: 'hidden'
                          }
                        : { maxHeight: 20 }
                    }
                    required
                    multiline
                    label='Locations'
                    variant='standard'
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      style: { fontSize: 13 }
                    }}
                    error={Boolean(validationErrors['locationsError'])}
                    helperText={validationErrors['locationsError']}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid
          sx={{
            marginTop: {
              xs: 7,
              sm: 3,
              md: 2,
              lg: 1,
              xl: 1
            },
            display: 'flex',
            flexDirection: 'row-reverse'
          }}
        >
          <Button
            fullWidth={isMobile ? true : false}
            disabled={
              (userPermissionsArr &&
                ((userPermissionsArr.filter(permissions => permissions.level3)
                  .length &&
                  !editedData) ||
                  (userPermissionsArr.filter(permissions => permissions.level4)
                    .length &&
                    editedData)) &&
                !disableCreateUserBtn) ||
              (UserIsAdmin && !disableCreateUserBtn)
                ? false
                : true
            }
            onClick={handleSignUp}
            style={{ backgroundColor: '#3361FF', width: '10%' }}
            className='BtnColor'
            variant='contained'
          >
            SAVE {createAgencyLoader && '...'}
          </Button>
        </Grid>
      </Box>
    </Paper>
  );

  const renderUserList = () => (
    <div class={isMobile ? 'mt-1 mx-2' : 'mt-2 mx-3'} style={{ border: '' }}>
      {adminRoles && (
        <MaterialReactTable
          state={{ isLoading: shipmentsLoader }}
          columns={userColumns}
          data={allUsers}
          enableRowSelection
          muiTableBodyRowProps={({ row }) => ({
            onClick: row.getToggleSelectedHandler()
          })}
          muiTableHeadCellFilterTextFieldProps={{ placeholder: '' }}
          muiTableContainerProps={{
            sx: { maxHeight: '70vh', minHeight: '70vh' }
          }}
          initialState={{
            density: 'compact'
          }}
          positionToolbarAlertBanner='bottom'
          renderToolbarInternalActions={({ table }) => (
            <div style={isMobile ? { fontSize: 10 } : {}}>
              <MRT_ToggleGlobalFilterButton table={table} title='Search' />
              <IconButton
                title='Print'
                onClick={() => {
                  handlePrint();
                }}
              >
                <LocalPrintshopOutlinedIcon />
              </IconButton>
              <MRT_ToggleFiltersButton table={table} title='Filters' />
              <MRT_ToggleDensePaddingButton table={table} title='Spacing' />
              <MRT_ShowHideColumnsButton
                table={table}
                title='Show/Hide Columns'
              />
              <MRT_FullScreenToggleButton table={table} title='Fullscreen' />
              <Tooltip title='Clear All Filters' arrow>
                <IconButton
                  onClick={() => {
                    table.resetColumnFilters(true);
                    table.setShowColumnFilters(false);
                  }}
                >
                  <FilterAltOffIcon />
                </IconButton>
              </Tooltip>
            </div>
          )}
          enableRowActions={isMobile ? true : false}
          renderRowActions={({ row, table }) => (
            <div>
              {((userPermissionsArr &&
                userPermissionsArr.filter(permissions => permissions.level4)
                  .length) ||
                UserIsAdmin) && (
                <button
                  onClick={event =>
                    handleResendEmailRequest(event, row.original)
                  }
                  class=' bg-white border-0 p-2 fw-bold'
                >
                  <Tooltip title='Resend Password'>
                    <svg
                      fill='rgb(51, 97, 255)'
                      width='24px'
                      height='16px'
                      viewBox='0 0 64.00 64.00'
                      data-name='Layer 1'
                      id='Layer_1'
                      xmlns='http://www.w3.org/2000/svg'
                      stroke='rgb(51, 97, 255)'
                      stroke-width='2.944'
                    >
                      <g id='SVGRepo_bgCarrier' stroke-width='0' />
                      <g
                        id='SVGRepo_tracerCarrier'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                        stroke='#CCCCCC'
                        stroke-width='0.256'
                      />
                      <g id='SVGRepo_iconCarrier'>
                        <title />
                        <path d='M55.43,55.68H8.57a5.51,5.51,0,0,1-5.5-5.5V13.82a5.51,5.51,0,0,1,5.5-5.5H55.43a5.51,5.51,0,0,1,5.5,5.5V50.18A5.51,5.51,0,0,1,55.43,55.68ZM8.57,11.32a2.5,2.5,0,0,0-2.5,2.5V50.18a2.5,2.5,0,0,0,2.5,2.5H55.43a2.5,2.5,0,0,0,2.5-2.5V13.82a2.5,2.5,0,0,0-2.5-2.5Z' />
                        <path d='M32,27.21a2,2,0,0,1-.42-.05l-17.25-5a1.5,1.5,0,0,1,.84-2.89L32,24.15l16.83-4.88a1.5,1.5,0,0,1,.84,2.89l-17.25,5A2,2,0,0,1,32,27.21Z' />
                        <path d='M39.14,49a1.49,1.49,0,0,1-1.06-.44L34.9,45.34A1.51,1.51,0,0,1,36,42.77H51.82a1.5,1.5,0,0,1,0,3H39.59l.61.62a1.51,1.51,0,0,1,0,2.12A1.53,1.53,0,0,1,39.14,49Z' />
                        <path d='M36,45.77a1.5,1.5,0,0,1-1.06-2.56L38.08,40a1.5,1.5,0,1,1,2.12,2.12L37,45.34A1.48,1.48,0,0,1,36,45.77Z' />
                      </g>
                    </svg>
                  </Tooltip>
                </button>
              )}
              {((userPermissionsArr &&
                userPermissionsArr.filter(permissions => permissions.level4)
                  .length) ||
                userPermissionsArr.filter(permissions => permissions.level2)
                  .length ||
                UserIsAdmin) &&
                row.original.roleName !== 'Default' && (
                  <button
                    onClick={event => handleEditUser(event, row.original)}
                    class='mx-2 bg-white border-0 p-2 fw-bold'
                    style={{ color: '#3361FF', borderRadius: '4px' }}
                  >
                    <Tooltip title='View / Update'>
                      <svg
                        className='MX-1'
                        width='17'
                        height='17'
                        viewBox='0 0 13 13'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M1.33333 11.1693H2.26667L8.01667 5.41927L7.08333 4.48594L1.33333 10.2359V11.1693ZM10.8667 4.4526L8.03333 1.6526L8.96667 0.719271C9.22222 0.463715 9.53611 0.335938 9.90833 0.335938C10.2806 0.335938 10.5944 0.463715 10.85 0.719271L11.7833 1.6526C12.0389 1.90816 12.1722 2.21649 12.1833 2.5776C12.1944 2.93872 12.0722 3.24705 11.8167 3.5026L10.8667 4.4526ZM9.9 5.43594L2.83333 12.5026H0V9.66927L7.06667 2.6026L9.9 5.43594Z'
                          fill='#3361FF'
                        />
                      </svg>
                    </Tooltip>
                  </button>
                )}
            </div>
          )}
          renderTopToolbarCustomActions={({ table }) => {
            return (
              <div
                style={
                  isMobile
                    ? {
                        display: 'flex',
                        flexDirection: 'column-reverse'
                      }
                    : { display: 'flex' }
                }
              >
                {((userPermissionsArr &&
                  userPermissionsArr.filter(permissions => permissions.level3)
                    .length) ||
                  UserIsAdmin) && (
                  <Button
                    size='small'
                    onClick={handleAddUser}
                    className='m-2'
                    style={
                      isMobile
                        ? {
                            fontSize: 10,
                            whiteSpace: 'nowrap',
                            color: '#3361FF',
                            backgroundColor: '#E4F3FD'
                          }
                        : {
                            color: '#3361FF',
                            backgroundColor: '#E4F3FD'
                          }
                    }
                    variant='contained'
                  >
                    Add User
                    <svg
                      className='ms-2'
                      width='11'
                      height='10'
                      viewBox='0 0 11 10'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M4.94531 9.72396V5.72396H0.945312V4.39062H4.94531V0.390625H6.27865V4.39062H10.2786V5.72396H6.27865V9.72396H4.94531Z'
                        fill='#3361FF'
                      />
                    </svg>
                  </Button>
                )}
              </div>
            );
          }}
        />
      )}
    </div>
  );

  return (
    <>
      <Dialog
        maxWidth='xl'
        maxHeight='xl'
        PaperProps={{
          sx: {
            height: {
              xs: '100%',
              sm: 'auto',
              md: '45vh',
              lg: '45vh',
              xl: '45vh'
            },
            width: {
              xs: '100%',
              sm: 'auto',
              md: '84vw',
              lg: '84vw',
              xl: '84vw'
            },
            m: {
              xs: 1,
              sm: 2
            }
          }
        }}
        open={createLocDialog}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>Create Location</DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            <AddLocations locationFlow={'TL'} handleClose={handleClose} />
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <MetaTags>
        <title>
          {' '}
          {base_url === 'https://beta.api.shiptechpro.com/'
            ? 'Users | Shiptechpro'
            : 'Users | TMS Shipping'}
        </title>
      </MetaTags>
      <ToastContainer
        style={
          isMobile
            ? { width: '100%', display: 'flex', justifyContent: 'center' }
            : { width: 'auto' }
        }
        position='top-center'
        autoClose={4800}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {currentView === 'list' ? renderUserList() : renderUserForm()}
    </>
  );
}

export default UserManagement;
